import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";

/**
 * Props for `TwoColumns`.
 */
export type TwoColumnsProps = SliceComponentProps<Content.TwoColumnsSlice>;

/**
 * Component for "TwoColumns" Slices.
 */
const TwoColumns: FC<TwoColumnsProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation} 
      className="font-fellix px-4 md:px-8 lg:px-12 2xl:px-0"
    >
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-12 gap-0 md:gap-6">
          {slice.primary.columns.map((item: any, index: number)=>{
              let imageData = null;
              if(item.no_crop === true) {
                imageData =  item.image?.url.split("?").shift();
              }
              return (
                <div className="col-span-12 md:col-span-6 mb-12" key={index}>
                  <div className="text-panel-wrapper">
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <div className="img-wrap"><img src={imageData ? imageData : item.image?.url}  alt={item.image.alt} /></div>
                    {item.title.length > 0 ?
                    <article className="font-semibold text-[28px] leading-[36px] mt-[48px] mb-[38px]"><PrismicRichText field={item.title} /></article>
                    : <div aria-hidden="true">&nbsp;</div>}
                    <article className="prose prose-a:text-blue-500 prose-a:no-underline prose-a:font-normal text-[18px] leading-[26px] font-normal max-w-[537px]"><PrismicRichText field={item.paragaraph} /></article>
                  </div>
                </div>
              )
          })}
        </div>
      </div>
    </section>
  );
};

export default TwoColumns;
